import { makeStyles, tokens } from '@fluentui/react-components';

export const useInputStyles = makeStyles({
    input: {
        minWidth: 0,
        width: '100%',
        margin: 0,
        borderRadius: '0.5rem',
        background: 'transparent',
        border: `1px solid ${tokens.colorNeutralStroke2}`,
        boxShadow: 'none !important',
        fontSize: '1rem',
        // Wrapper padding controls space between left border and the icon
        paddingLeft: '0.5rem',
        paddingRight: tokens.spacingHorizontalM,
        marginRight: '15px',
        height: '56px',
        fontFamily: 'var(--DefaultFontFamily)',
        outline: 'none',
        caretColor: tokens.colorBrandForeground1,

        /* Ensure contentAfter aligns correctly */
        '& .fui-Input__contentAfter': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%',
            boxSizing: 'border-box',
        },

        '&:focus-within': {
            outline: '2px solid var(--color-primary-400) !important',
            outlineOffset: '2px !important',
            border: `1px solid ${tokens.colorNeutralStroke2} !important`,
            boxShadow: 'none !important',
            background: 'transparent !important',
        },

        '&::placeholder': {
            color: tokens.colorNeutralForeground3,
            fontFamily: 'var(--DefaultFontFamily)',
            paddingLeft: '0 !important', /* Reset any default placeholder padding */
            borderBottom: 'none !important',
        },

        '&:focus::after': {
            display: 'none !important',
            content: 'none !important',
        },

        '& .fui-Input': {
            '&::after': {
                display: 'none !important',
                content: 'none !important',
            }
        },

        '& .fui-Input__input': {
            paddingLeft: '0.25rem !important',
        },

        '& div::after': {
            display: 'none !important',
            content: 'none !important',
            borderBottom: 'none !important',
        },
        '& .fui-Input__input:focus + div::after': {
            display: 'none !important',
        },
        '&:focus-within::after': {
            display: 'none !important',
            content: 'none !important',
            borderBottom: 'none !important',
        },
    },
});
